var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1466_4635)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9689 63.6456C64.0189 65.6419 62.2723 66.8174 60.935 67.703C47.8954 76.351 32.9918 73.8601 28.3855 73.0083C20.9506 71.6334 14.6733 70.6624 9.28225 65.8258C-2.97009 54.8293 -2.37312 31.894 6.98819 17.6869C8.09872 16.0039 17.447 2.23963 32.3818 0.300302C32.7468 0.253696 33.0205 0.227803 33.2603 0.201911C35.57 -0.0414759 49.8896 -1.32314 61.5632 8.39162C63.2342 9.78204 65.9246 12.291 68.4193 16.1179C77.5382 30.1048 77.5669 51.7715 65.9689 63.6456Z",
    fill: "#FBF9ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0917 31.0241C14.2523 29.468 9.69286 29.0589 10.6887 25.8819C11.4186 23.5542 14.6147 22.5237 10.2716 19.4787C5.92852 16.4338 3.96033 9.18141 8.4572 8.03698C11.038 7.37932 12.3779 11.6127 15.196 12.1254C17.8706 12.6147 18.9994 14.8104 18.4259 17.7336C17.8524 20.6568 19.453 21.0556 21.5281 22.3295C24.0203 23.8597 21.8905 26.6897 20.952 27.8859C20.1934 28.8543 19.4556 31.9381 21.0823 32.9039C22.1303 33.5227 21.7679 34.3797 21.2361 35.1798C20.8607 35.1004 20.4854 35.021 20.11 34.9416C18.2226 34.403 16.6949 33.5978 15.4489 32.6605C15.428 32.6449 15.4071 32.6294 15.3863 32.6139C15.4384 32.0986 15.3733 31.5523 15.0917 31.0241Z",
    fill: "url(#paint0_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60156 8.23672L6.6902 8.13574C14.1224 14.368 18.4655 24.321 18.0223 34.1082L17.8868 34.1005C18.3273 24.3546 14.0025 14.4457 6.60156 8.23672Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6601 22.7832L22.7227 22.9023C22.6836 22.923 18.7342 25.041 17.8009 28.7773L17.668 28.7462C18.6195 24.9504 22.621 22.8065 22.6601 22.7832Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1523 26.4081L10.1941 26.2812C10.2618 26.302 17.0736 28.4847 18.0512 32.2649L17.9209 32.2986C16.9615 28.5908 10.2201 26.4288 10.1523 26.4081Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4576 12.5137L17.5644 12.5939C17.5358 12.6328 14.663 16.426 15.1765 19.4813L15.0436 19.502C14.5196 16.3923 17.4289 12.5499 17.4576 12.5137Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72461 11.4735L4.72722 11.3389C4.77675 11.3415 9.57341 11.4735 12.0604 13.9902L11.9639 14.086C9.51605 11.6056 4.77153 11.4735 4.72461 11.4735Z",
    fill: "#FCFDFE"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6239 41.6938L17.9503 41.2044C17.283 38.8758 17.5541 36.9521 18.7637 35.433C22.4654 30.7828 18.1067 27.888 16.4644 26.4044C13.9852 24.1673 13.0259 21.4409 16.3158 19.9598C20.0384 18.2846 17.2699 12.8939 12.7444 9.85151C8.31527 6.8765 11.0864 -2.65961 21.2663 2.90722C27.3455 6.23178 25.8648 12.7851 25.9117 16.2728C25.9561 19.7579 31.1203 20.4285 29.0296 24.5272C27.2439 28.0305 24.1651 30.454 26.1803 33.1027C28.1928 35.7489 28.211 38.5531 24.6239 41.6938Z",
    fill: "url(#paint1_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6889 42.0984L21.5533 42.0622C21.5742 41.9793 23.7561 33.554 23.3834 24.5539C23.0392 16.2632 20.3933 5.77421 9.74414 2.88464L9.78064 2.75C14.5226 4.03684 18.0966 6.90829 20.4089 11.2893C22.2572 14.7873 23.3052 19.2485 23.5241 24.5513C23.8969 33.5721 21.7123 42.013 21.6889 42.0984Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2955 13.1582L21.1573 13.1323C22.0827 8.55457 20.8001 1.85884 20.7871 1.79152L20.9253 1.76562C20.9383 1.83294 22.2261 8.55457 21.2955 13.1582Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6762 10.2838C15.1532 7.00071 10.6173 8.08041 10.573 8.09336L10.5391 7.95613C10.5834 7.94578 15.1793 6.84536 19.7596 10.1699L19.6762 10.2838Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3061 30.4521C22.2216 23.7382 13.3113 21.4571 13.2227 21.4416L13.2383 21.3018C13.3269 21.3095 22.352 23.6579 23.4442 30.4288L23.3061 30.4521Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5555 27.6577L23.4199 27.6188C24.6243 23.4502 29.4653 20.8765 29.5148 20.8506L29.58 20.9749C29.5331 21.0008 24.7416 23.546 23.5555 27.6577Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8657 40.7278C21.8553 38.1464 18.3177 35.842 18.2812 35.8187L18.3569 35.7021C18.5054 35.7954 21.9961 38.0687 22.0091 40.7278H21.8657Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4116 38.7394L22.2734 38.7057C22.7687 36.725 25.9909 34.7132 27.0492 34.0529C27.1978 33.9597 27.3282 33.8795 27.3464 33.8613L27.4455 33.9623C27.4168 33.9882 27.3334 34.0426 27.1248 34.172C26.0769 34.8245 22.8913 36.813 22.4116 38.7394Z",
    fill: "#BEB8F2"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5587 17.3451V60.9295C33.5587 61.4707 33.0999 61.9419 32.5316 61.9782L4.66658 63.7958C4.02008 63.8372 3.49609 63.4023 3.49609 62.8223V16.2059C3.49609 15.6233 4.02008 15.1754 4.66658 15.2013L32.5316 16.3224C33.0999 16.3431 33.5587 16.804 33.5587 17.3451Z",
    fill: "url(#paint2_linear_1466_4635)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5587 17.3451V60.9295C33.5587 61.4707 33.0999 61.9419 32.5316 61.9782L4.66658 63.7958C4.02008 63.8372 3.49609 63.4023 3.49609 62.8223V16.2059C3.49609 15.6233 4.02008 15.1754 4.66658 15.2013L32.1718 17.0707C32.7401 17.094 33.5587 16.804 33.5587 17.3451Z",
    fill: "url(#paint3_linear_1466_4635)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1231 17.3451V60.9295C34.1231 61.4707 33.6643 61.9419 33.096 61.9782L5.23104 63.7958C4.58453 63.8372 4.06055 63.4023 4.06055 62.8223V16.2059C4.06055 15.6233 4.58453 15.1754 5.23104 15.2013L33.096 16.3224C33.6643 16.3431 34.1231 16.804 34.1231 17.3451Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1137 62.1724L5.23104 63.7958C4.58453 63.8372 4.06055 63.4023 4.06055 62.8223V16.2059C4.06055 15.6233 4.58453 15.1754 5.23104 15.2013L14.389 15.5689C11.9672 20.4652 12.3009 23.8441 13.1481 26.0812C15.3536 31.9147 21.803 32.1762 23.4714 38.0952C24.8218 42.8749 21.279 45.068 21.7535 50.3526C22.0428 53.5994 23.839 57.7888 30.1137 62.1724Z",
    fill: "#D8DEE8"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5189 17.3221V60.9661C33.5189 61.1914 33.3286 61.383 33.0966 61.3985L5.23162 63.1799C4.96832 63.1954 4.75195 63.0168 4.75195 62.7785V16.2321C4.75195 15.9939 4.96832 15.8074 5.23162 15.8178L33.0966 16.9027C33.3286 16.9104 33.5189 17.0995 33.5189 17.3221Z",
    fill: "url(#paint4_linear_1466_4635)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5978 37.3158C14.3737 37.3572 10.0332 33.4138 10.0332 28.5254C10.0332 23.6369 14.3737 19.7945 19.5978 19.955C24.7021 20.113 28.7689 24.0538 28.7689 28.7403C28.7689 33.4268 24.7021 37.2744 19.5978 37.3158Z",
    fill: "#D8DEE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1497 28.7323C28.1497 33.1107 24.3619 36.6838 19.5991 36.7174C14.7321 36.7485 10.707 33.0848 10.707 28.5329C10.707 23.9811 14.7321 20.4105 19.5991 20.5529C24.3619 20.6954 28.1497 24.3565 28.1497 28.7323Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.9872 41.3138C30.9872 41.8291 30.5493 42.2563 30.0045 42.2666L8.68277 42.6835C8.08319 42.6938 7.5957 42.264 7.5957 41.7203C7.5957 41.1766 8.08319 40.7286 8.68277 40.7209L30.0045 40.3946C30.5493 40.3869 30.9872 40.7986 30.9872 41.3138Z",
    fill: "url(#paint5_linear_1466_4635)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9878 44.9882C30.9878 45.5034 30.5498 45.9332 30.005 45.9488L12.5571 46.4381C11.9679 46.4537 11.4883 46.0316 11.4883 45.4931C11.4883 44.9545 11.9679 44.5066 12.5571 44.4937L30.005 44.0794C30.5498 44.0665 30.9878 44.473 30.9878 44.9882Z",
    fill: "#D8DEE8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6932 46.5461H8.67235C8.07798 46.5616 7.5957 46.1551 7.5957 45.6347V45.5492C7.5957 45.0314 8.07798 44.599 8.67235 44.5834H8.6932C9.28496 44.5679 9.76463 44.977 9.76463 45.4949V45.5803C9.76463 46.0956 9.28496 46.528 8.6932 46.5461Z",
    fill: "#B19AF3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68298 46.7301C7.97131 46.7508 7.39258 46.2433 7.39258 45.5986C7.39258 44.9539 7.97131 44.4153 8.68298 44.3998C9.39206 44.3842 9.96818 44.8917 9.96818 45.5313C9.96818 46.1734 9.39206 46.7094 8.68298 46.7301ZM8.68298 44.7674C8.1955 44.7804 7.79925 45.1481 7.79925 45.5882C7.79925 46.0284 8.1955 46.3754 8.68298 46.3624C9.16786 46.3495 9.5615 45.9818 9.5615 45.5416C9.5615 45.104 9.16786 44.7571 8.68298 44.7674Z",
    fill: "#D8DEE8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9878 48.3128C30.9878 48.828 30.5498 49.263 30.005 49.2812L12.5571 49.9052C11.9679 49.9259 11.4883 49.5064 11.4883 48.9679C11.4883 48.4293 11.9679 47.9762 12.5571 47.958L30.005 47.4117C30.5498 47.3936 30.9878 47.7975 30.9878 48.3128Z",
    fill: "#D8DEE8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6932 50.0423H8.67235C8.07798 50.063 7.5957 49.6591 7.5957 49.1413V49.0532C7.5957 48.5354 8.07798 48.0978 8.67235 48.0797H8.6932C9.28496 48.0616 9.76463 48.4655 9.76463 48.9807V49.0688C9.76463 49.584 9.28496 50.0216 8.6932 50.0423Z",
    fill: "#B19AF3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68298 50.2256C7.97131 50.2515 7.39258 49.7466 7.39258 49.1045C7.39258 48.4598 7.97131 47.916 8.68298 47.8953C9.39206 47.872 9.96818 48.3769 9.96818 49.0164C9.96818 49.6586 9.39206 50.1997 8.68298 50.2256ZM8.68298 48.263C8.1955 48.2785 7.79925 48.6488 7.79925 49.0889C7.79925 49.5291 8.1955 49.8735 8.68298 49.8579C9.16786 49.8398 9.5615 49.4695 9.5615 49.032C9.5615 48.5918 9.16786 48.2474 8.68298 48.263Z",
    fill: "#D8DEE8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9878 51.6398C30.9878 52.1551 30.5498 52.59 30.005 52.6134L12.5571 53.3694C11.9679 53.3953 11.4883 52.9784 11.4883 52.4399C11.4883 51.9013 11.9679 51.4482 12.5571 51.4249L30.005 50.7439C30.5498 50.7232 30.9878 51.122 30.9878 51.6398Z",
    fill: "#D8DEE8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68298 53.7211C7.97131 53.7521 7.39258 53.2524 7.39258 52.6077C7.39258 51.9656 7.97131 51.4193 8.68298 51.3908C9.39206 51.3623 9.96818 51.862 9.96818 52.5041C9.96818 53.1437 9.39206 53.69 8.68298 53.7211ZM8.68298 51.7585C8.1955 51.7766 7.79925 52.152 7.79925 52.5922C7.79925 53.0323 8.1955 53.3741 8.68298 53.3534C9.16786 53.3327 9.5615 52.9573 9.5615 52.5197C9.5615 52.0821 9.16786 51.7403 8.68298 51.7585Z",
    fill: "#D8DEE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9878 54.9645C30.9878 55.4798 30.5498 55.9199 30.005 55.9484L12.5571 56.8365C11.9679 56.865 11.4883 56.4533 11.4883 55.9147C11.4883 55.3762 11.9679 54.9179 12.5571 54.8894L30.005 54.0764C30.5498 54.0505 30.9878 54.4492 30.9878 54.9645Z",
    fill: "#D8DEE8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6932 57.0324H8.67235C8.07798 57.0635 7.5957 56.6674 7.5957 56.1469V56.0615C7.5957 55.541 8.07798 55.0983 8.67235 55.0698H8.6932C9.28496 55.0413 9.76463 55.4375 9.76463 55.9553V56.0408C9.76463 56.5586 9.28496 57.0014 8.6932 57.0324Z",
    fill: "#B19AF3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68298 57.2167C7.97131 57.2529 7.39258 56.7584 7.39258 56.1137C7.39258 55.469 7.97131 54.92 8.68298 54.8864C9.39206 54.8527 9.96818 55.3473 9.96818 55.9894C9.96818 56.6289 9.39206 57.1804 8.68298 57.2167ZM8.68298 55.2541C8.1955 55.2774 7.79925 55.6554 7.79925 56.0955C7.79925 56.5357 8.1955 56.8723 8.68298 56.849C9.16786 56.8231 9.5615 56.4477 9.5615 56.0075C9.5615 55.5699 9.16786 55.2307 8.68298 55.2541Z",
    fill: "#D8DEE8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0589 23.9146C21.3665 23.855 22.2086 23.7307 22.975 24.1657C24.1246 24.8208 24.2159 26.2371 24.2341 26.5374C24.3332 28.0651 23.2982 28.4069 23.5694 29.4633C23.8822 30.688 25.3942 30.6957 25.7461 31.8738C26.1398 33.1917 24.6825 34.6236 24.5052 34.7971C22.3884 36.871 18.2174 36.9383 15.548 35.3304C14.9536 34.9731 13.4494 34.0669 13.2487 32.6402C13.0662 31.3379 14.1689 30.9987 14.6408 29.0127C15.1517 26.8559 14.1038 26.1957 14.8884 24.8674C15.5401 23.767 17.0052 22.9773 18.5511 23.0213C19.7842 23.0549 20.6861 23.6427 21.0589 23.9146Z",
    fill: "#26264F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 34.095C15.9173 31.2917 21.7315 31.2874 28.1497 34.082C27.3329 36.4779 24.4827 37.757 19.5991 37.9192C14.5504 38.0884 11.5864 36.8136 10.707 34.095Z",
    fill: "url(#paint6_linear_1466_4635)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5424 28.6476L20.618 30.3617C20.6519 31.0996 21.1576 31.7495 21.9006 32.0084L24.5179 32.8525C20.6892 34.2006 17.2569 34.1998 14.2207 32.8499L16.6008 32.1094C17.3125 31.8867 17.8234 31.3145 17.9251 30.6284L18.2171 28.6191L20.5424 28.6476Z",
    fill: "url(#paint7_linear_1466_4635)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7624 26.8892C21.7624 28.5825 20.657 30.395 19.2858 30.3846C17.9068 30.3743 16.7832 28.5256 16.7832 26.8115C16.7832 25.0974 17.9068 24.186 19.2858 24.2145C20.657 24.243 21.7624 25.1932 21.7624 26.8892Z",
    fill: "url(#paint8_linear_1466_4635)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3832 25.3338C19.6377 25.3571 18.5115 25.5021 17.7294 26.2478C16.4155 27.4983 17.0386 29.5179 16.4547 29.6319C15.9359 29.7328 15.1277 28.2906 15.1408 26.7164C15.1538 25.3985 15.6413 23.8553 16.9135 23.4928C17.659 23.2805 17.8806 23.6585 20.2868 23.9278C21.6867 24.0858 21.1366 24.6554 21.452 24.8781C22.8519 25.8671 22.6747 29.0234 21.9213 29.0571C21.5641 29.0726 21.0714 28.2389 20.3832 25.3338Z",
    fill: "#26264F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3661 61.6367L5.23162 63.1799C4.96832 63.1954 4.75195 63.0168 4.75195 62.7785V16.2321C4.75195 15.9939 4.96832 15.8074 5.23162 15.8178L14.1054 16.1647C11.9965 20.7399 12.338 23.9376 13.1487 26.0815C15.3541 31.915 21.8036 32.1765 23.472 38.0955C24.8223 42.8752 21.2796 45.0683 21.754 50.3529C22.033 53.4651 23.6936 57.4447 29.3661 61.6367Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1594 18.425V59.1406C71.1594 59.6481 70.7579 60.0857 70.2626 60.1167L46.0551 61.6962C45.4946 61.7324 45.041 61.3259 45.041 60.7848V17.4333C45.041 16.8922 45.4946 16.4727 46.0551 16.496L70.2626 17.4696C70.7579 17.4903 71.1594 17.9175 71.1594 18.425Z",
    fill: "url(#paint9_linear_1466_4635)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1594 18.425V59.1406C71.1594 59.6481 70.7579 60.0857 70.2626 60.1167L46.0551 61.6962C45.4946 61.7324 45.041 61.3259 45.041 60.7848V17.4333C45.041 16.8922 45.4946 16.4727 46.0551 16.496L70.0045 18.9713C70.4998 18.9921 71.1594 17.9175 71.1594 18.425Z",
    fill: "url(#paint10_linear_1466_4635)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7257 18.425V59.1406C71.7257 59.6481 71.3269 60.0857 70.829 60.1167L46.6215 61.6962C46.0636 61.7324 45.6074 61.3259 45.6074 60.7848V17.4333C45.6074 16.8922 46.0636 16.4727 46.6215 16.496L70.829 17.4696C71.3269 17.4903 71.7257 17.9175 71.7257 18.425Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2273 60.2876L46.6215 61.6962C46.0636 61.7324 45.6074 61.3259 45.6074 60.7848V17.4333C45.6074 16.8922 46.0636 16.4727 46.6215 16.496L54.5542 16.8145C52.4531 21.3793 52.7451 24.5252 53.4776 26.6096C55.391 32.0392 60.9932 32.2826 62.4452 37.8002C63.621 42.2614 60.5396 44.3043 60.9489 49.2316C61.2018 52.2584 62.7633 56.1733 68.2273 60.2876Z",
    fill: "#D8DEE8"
  })))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1999 18.4042V59.1741C71.1999 59.3812 71.033 59.5625 70.8297 59.5754L46.6222 61.1212C46.3928 61.1367 46.2051 60.9684 46.2051 60.7458V17.4565C46.2051 17.2339 46.3928 17.0604 46.6222 17.0708L70.8297 18.0132C71.033 18.021 71.1999 18.1971 71.1999 18.4042Z",
    fill: "url(#paint11_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5763 59.7826L46.6222 61.1212C46.3928 61.1367 46.2051 60.9684 46.2051 60.7458V17.4565C46.2051 17.2339 46.3928 17.0604 46.6222 17.0708L54.3073 17.3685C52.4798 21.6356 52.7744 24.6106 53.4783 26.6094C55.3917 32.039 60.9939 32.2824 62.4459 37.8001C63.6216 42.2613 60.5403 44.3042 60.9496 49.2315C61.192 52.134 62.6389 55.8495 67.5763 59.7826Z",
    fill: "white"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.077 37.0723C54.541 37.1086 50.7793 33.4371 50.7793 28.8878C50.7793 24.336 54.541 20.7499 59.077 20.8897C63.5166 21.0269 67.0567 24.6959 67.0567 29.0716C67.0567 33.4474 63.5166 37.0361 59.077 37.0723Z",
    fill: "#D8DEE8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5178 29.0662C66.5178 33.152 63.2201 36.4869 59.0777 36.5154C54.852 36.5413 51.3613 33.1313 51.3613 28.8927C51.3613 24.6567 54.852 21.3244 59.0777 21.4487C63.2201 21.5704 66.5178 24.9804 66.5178 29.0662Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.9912 40.8113C68.9912 41.2929 68.608 41.6916 68.1336 41.6994L49.6091 42.0619C49.0903 42.0722 48.668 41.6709 48.668 41.166C48.668 40.6611 49.0903 40.2442 49.6091 40.2364L68.1336 39.9542C68.608 39.9464 68.9912 40.3297 68.9912 40.8113Z",
    fill: "url(#paint12_linear_1466_4635)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9916 44.2448C68.9916 44.7238 68.6084 45.1251 68.1339 45.1381L52.9671 45.5627C52.4562 45.5782 52.0391 45.1821 52.0391 44.6823C52.0391 44.18 52.4562 43.7632 52.9671 43.7528L68.1339 43.3929C68.6084 43.38 68.9916 43.7632 68.9916 44.2448Z",
    fill: "#D8DEE8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6169 45.6583H49.5986C49.0851 45.6712 48.668 45.2932 48.668 44.809V44.7287C48.668 44.2446 49.0851 43.8432 49.5986 43.8329L49.6169 43.8303C50.1304 43.8199 50.5449 44.198 50.5449 44.6795V44.7598C50.5449 45.2414 50.1304 45.6427 49.6169 45.6583Z",
    fill: "#B19AF3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6086 45.8292C48.9934 45.8473 48.4902 45.3735 48.4902 44.7728C48.4902 44.1747 48.9934 43.675 49.6086 43.6594C50.2212 43.6465 50.7191 44.1203 50.7191 44.7158C50.7191 45.3114 50.2212 45.8111 49.6086 45.8292ZM49.6086 44.0038C49.1863 44.0116 48.8448 44.3534 48.8448 44.765C48.8448 45.1741 49.1863 45.4978 49.6086 45.4874C50.0283 45.4745 50.3698 45.1327 50.3698 44.7236C50.3698 44.3171 50.0283 43.9934 49.6086 44.0038Z",
    fill: "#D8DEE8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9916 47.3489C68.9916 47.8305 68.6084 48.2345 68.1339 48.25L52.9671 48.7911C52.4562 48.8093 52.0391 48.4183 52.0391 47.916C52.0391 47.4137 52.4562 46.9942 52.9671 46.9787L68.1339 46.5023C68.6084 46.4893 68.9916 46.8674 68.9916 47.3489Z",
    fill: "#D8DEE8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6169 48.91H49.5986C49.0851 48.9281 48.668 48.5527 48.668 48.0685V47.9883C48.668 47.5041 49.0851 47.1001 49.5986 47.0846H49.6169C50.1304 47.0665 50.5449 47.4445 50.5449 47.9261V48.0064C50.5449 48.488 50.1304 48.8919 49.6169 48.91Z",
    fill: "#B19AF3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6086 49.0809C48.9934 49.1042 48.4902 48.633 48.4902 48.0349C48.4902 47.4342 48.9934 46.9319 49.6086 46.9137C50.2212 46.893 50.7191 47.3643 50.7191 47.9598C50.7191 48.5553 50.2212 49.0602 49.6086 49.0809ZM49.6086 47.2555C49.1863 47.2685 48.8448 47.6128 48.8448 48.0219C48.8448 48.4336 49.1863 48.7547 49.6086 48.7391C50.0283 48.7236 50.3698 48.3792 50.3698 47.9727C50.3698 47.5636 50.0283 47.2426 49.6086 47.2555Z",
    fill: "#D8DEE8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9916 50.4538C68.9916 50.9354 68.6084 51.3419 68.1339 51.3626L52.9671 52.0177C52.4562 52.041 52.0391 51.6526 52.0391 51.1503C52.0391 50.648 52.4562 50.2259 52.9671 50.2078L68.1339 49.6149C68.6084 49.5968 68.9916 49.9722 68.9916 50.4538Z",
    fill: "#D8DEE8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6169 52.1622L49.5986 52.1648C49.0851 52.1855 48.668 51.8126 48.668 51.3284V51.2482C48.668 50.7666 49.0851 50.3575 49.5986 50.3368H49.6169C50.1304 50.316 50.5449 50.6915 50.5449 51.1705V51.2508C50.5449 51.7324 50.1304 52.1415 49.6169 52.1622Z",
    fill: "#B19AF3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6086 52.3357C48.9934 52.3616 48.4902 51.8955 48.4902 51.2974C48.4902 50.6967 48.9934 50.1892 49.6086 50.1659C50.2212 50.1426 50.7191 50.6086 50.7191 51.2042C50.7191 51.7997 50.2212 52.3072 49.6086 52.3357ZM49.6086 50.5077C49.1863 50.5258 48.8448 50.8728 48.8448 51.2819C48.8448 51.691 49.1863 52.0094 49.6086 51.9913C50.0283 51.9732 50.3698 51.6262 50.3698 51.2197C50.3698 50.8106 50.0283 50.4921 49.6086 50.5077Z",
    fill: "#D8DEE8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9916 53.5577C68.9916 54.0393 68.6084 54.4484 68.1339 54.4717L52.9671 55.2459C52.4562 55.2718 52.0391 54.886 52.0391 54.3837C52.0391 53.884 52.4562 53.4568 52.9671 53.4335L68.1339 52.7266C68.6084 52.7033 68.9916 53.0762 68.9916 53.5577Z",
    fill: "#D8DEE8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6169 55.4169H49.5986C49.0851 55.4428 48.668 55.0726 48.668 54.5884V54.5081C48.668 54.0265 49.0851 53.6148 49.5986 53.5915L49.6169 53.5889C50.1304 53.5656 50.5449 53.9359 50.5449 54.4175V54.4978C50.5449 54.9794 50.1304 55.3885 49.6169 55.4169Z",
    fill: "#B19AF3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6086 55.588C48.9934 55.619 48.4902 55.1582 48.4902 54.5575C48.4902 53.9594 48.9934 53.4467 49.6086 53.4182C50.2212 53.3898 50.7191 53.8532 50.7191 54.4487C50.7191 55.0442 50.2212 55.5569 49.6086 55.588ZM49.6086 53.7626C49.1863 53.7807 48.8448 54.1303 48.8448 54.5394C48.8448 54.951 49.1863 55.2669 49.6086 55.2462C50.0283 55.2229 50.3698 54.8734 50.3698 54.4669C50.3698 54.0578 50.0283 53.7419 49.6086 53.7626Z",
    fill: "#D8DEE8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3613 34.0902C55.8817 31.4768 60.9338 31.4725 66.5178 34.0773C65.807 36.3126 63.327 37.5054 59.0777 37.6556C54.6947 37.8109 52.1225 36.6225 51.3613 34.0902Z",
    fill: "url(#paint13_linear_1466_4635)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8995 28.9921L59.9647 30.5896C59.9934 31.2783 60.7155 32.2648 61.362 32.5056C60.4287 34.0618 57.7567 34.1239 56.3594 32.4772C57.1536 32.1803 57.575 31.6348 57.6237 30.8408L57.8766 28.9688L59.8995 28.9921Z",
    fill: "url(#paint14_linear_1466_4635)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9576 27.3527C60.9576 28.9322 59.9983 30.6203 58.807 30.6126C57.6078 30.6048 56.6328 28.8804 56.6328 27.2854C56.6328 25.6879 57.6078 24.836 58.807 24.8619C59.9983 24.8878 60.9576 25.7707 60.9576 27.3527Z",
    fill: "url(#paint15_linear_1466_4635)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4337 27.029C56.2486 26.3739 56.0374 26.2186 55.9592 25.8794C55.8132 25.2373 56.2668 24.476 56.8482 24.0747C57.698 23.4869 58.6599 23.7899 58.8528 23.852C59.4107 24.0281 59.7757 24.3621 59.9477 24.5433C60.6829 24.3388 60.9905 24.5822 61.0609 24.6417C61.4102 24.9473 61.3242 25.5531 61.2016 26.4386C61.1182 27.0316 60.9853 27.5183 60.8758 27.8601C60.7698 27.8653 60.6646 27.8696 60.5604 27.8731C60.7715 27.2646 60.6881 26.9151 60.5604 26.7053C60.37 26.3946 60.0207 26.2911 59.8148 25.8224C59.7444 25.6567 59.7157 25.5091 59.7027 25.4107C59.687 25.5661 59.6349 25.7629 59.4811 25.8716C59.2022 26.0606 58.8711 25.8017 58.3184 25.7551C57.8336 25.7137 57.1975 25.9389 56.9264 26.4205C56.6448 26.9228 56.8716 27.5054 56.9264 27.6349C56.8064 27.6521 56.6865 27.6694 56.5666 27.6866C56.5484 27.5391 56.5119 27.306 56.4337 27.029Z",
    fill: "url(#paint16_linear_1466_4635)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6582 27.9296C60.7503 27.4705 60.9363 27.2659 61.2161 27.316C61.6358 27.3885 61.0362 28.5148 60.6582 28.6469V27.9296Z",
    fill: "url(#paint17_linear_1466_4635)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9006 28.6004C56.5174 28.458 55.9021 27.3006 56.3323 27.2385C56.6173 27.197 56.8067 27.4102 56.9006 27.878V28.6004Z",
    fill: "url(#paint18_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.305 60.7433L46.6215 61.6962C46.0636 61.7324 45.6074 61.3259 45.6074 60.7848V17.4333C45.6074 16.8922 46.0636 16.4727 46.6215 16.496L60.318 17.1356L60.305 60.7433Z",
    fill: "#D8DEE8"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7369 54.9869C58.2453 56.0744 57.7604 57.1645 57.2963 57.8998C57.1843 57.8998 57.1217 57.9309 57.0096 57.9568C55.9981 58.2027 55.5237 58.0785 54.4966 58.1509C54.275 58.1665 53.618 58.0034 53.3547 57.9179L52.8647 57.7496C52.2859 55.9838 52.4519 54.8566 53.3626 54.3681C54.726 53.6353 54.2046 50.9969 54.0899 49.5573C53.7797 45.6554 58.0263 46.0101 58.0315 40.9611C58.0315 39.6199 57.5831 37.0566 58.7223 35.9872C60.0205 34.7703 60.9694 35.9665 61.8036 34.9463C63.1097 33.354 65.2265 32.7817 66.4882 34.4207C67.7343 36.039 66.2197 39.2574 62.458 41.8466C59.9684 44.006 59.9319 44.6533 60.1274 46.2276C60.263 47.3306 61.324 50.2046 59.8146 51.3517C58.3078 52.4987 57.1556 53.7389 57.7369 54.9869Z",
    fill: "url(#paint19_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0326 58.1931L54.957 58.1827C55.0144 57.74 55.0769 57.292 55.1421 56.8544C55.6296 53.6153 56.4065 50.5367 57.4466 47.7067C58.3303 45.3091 59.4148 43.0565 60.6713 41.0084C61.6802 39.3617 62.809 37.8418 64.0212 36.485C64.8736 35.5322 65.7573 34.67 66.6515 33.9243C66.8079 33.7948 66.9722 33.6705 67.1338 33.5514C67.3502 33.3909 67.5717 33.2252 67.7699 33.0439L67.8194 33.0983C67.6187 33.2822 67.3971 33.4479 67.1807 33.611C67.0191 33.7301 66.8548 33.8544 66.701 33.9812C65.8095 34.7269 64.9257 35.584 64.0759 36.5342C62.8689 37.8884 61.7427 39.4057 60.7339 41.0472C59.48 43.0901 58.3981 45.3402 57.517 47.7326C56.4795 50.5575 55.7052 53.6309 55.2177 56.8674C55.1499 57.3024 55.09 57.7503 55.0326 58.1931Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3106 43.6002L59.2402 43.5691C60.6192 40.6511 59.4097 35.2629 59.3966 35.2086L59.4696 35.1904C59.4827 35.2448 60.7 40.6614 59.3106 43.6002Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1739 52.0982L56.1035 52.0723C56.8048 49.9828 60.749 48.3671 60.7881 48.3516L60.8168 48.4215C60.7777 48.437 56.8673 50.0397 56.1739 52.0982Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8787 53.3173L55.8031 53.307C56.0117 51.8829 55.5294 49.8297 54.4475 47.5253C54.3928 47.4113 54.3928 47.4113 54.3954 47.3958L54.4684 47.4062L54.4319 47.401L54.4684 47.3906C54.471 47.401 54.4918 47.4424 54.5153 47.4942C55.605 49.8115 56.0899 51.8803 55.8787 53.3173Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1466 57.3857L55.0762 57.352C55.7487 55.915 58.0454 55.348 58.0689 55.3428L58.0871 55.4153C58.0637 55.4205 55.8035 55.9797 55.1466 57.3857Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9174 58.1982C54.6333 56.9527 53.979 55.7462 52.918 54.5111L52.9753 54.4619C54.0441 55.7073 54.7037 56.9243 54.993 58.1826L54.9174 58.1982Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3764 37.345L63.3086 37.3087C64.1663 35.7293 64.6981 33.8728 64.8727 33.2644C64.9144 33.1168 64.9301 33.065 64.9379 33.0469L65.0057 33.0805C65.0005 33.0935 64.977 33.1763 64.9457 33.2851C64.7711 33.8961 64.2366 35.7578 63.3764 37.345Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M61.599 39.709L61.5469 39.6546C62.7539 38.4739 66.1428 38.5127 66.2862 38.5153L66.2836 38.5904C66.2497 38.5904 62.7851 38.5516 61.599 39.709Z",
    fill: "#FCFDFE"
  })))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9463 58.5237C54.9145 57.3327 53.5615 55.0023 53.3139 52.3044C53.0245 49.1455 56.5073 50.0207 57.4301 47.7966C58.353 45.5724 59.0829 40.9947 63.8326 40.3991C71.7862 39.4023 71.1214 46.2171 67.5187 47.0068C63.8378 47.8147 60.6809 50.5722 62.6387 52.5866C64.3696 54.368 63.0558 55.8749 60.8921 56.6828C59.4583 57.2187 55.9234 57.9748 57.1043 61.8923C57.4918 63.1713 57.1729 64.4729 56.1476 65.7968L51.7419 64.4271C50.2456 61.5039 50.9755 59.7121 52.9463 58.5237Z",
    fill: "url(#paint20_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8407 53.7104C58.3397 50.3651 60.154 47.7681 62.2343 45.9893C64.8386 43.7652 67.8704 42.8279 71.2385 43.2007L71.2281 43.2965C63.6577 42.4576 59.2729 48.5164 56.9293 53.7467C54.385 59.4248 53.6238 65.3775 53.616 65.437L53.5195 65.4267C53.5274 65.3671 54.2886 59.3989 56.8407 53.7104Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3444 39.7549L64.4279 39.8067C64.4018 39.8455 61.8653 43.8148 61.284 46.984L61.1875 46.9685C61.7714 43.7785 64.3184 39.7937 64.3444 39.7549Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9395 45.4383C66.7272 44.4647 69.3941 46.3315 69.4201 46.3497L69.3628 46.4273C69.3367 46.4092 66.7064 44.5709 62.9655 45.5315L62.9395 45.4383Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3867 57.4992C57.8215 53.4342 64.211 54.2084 64.271 54.2265L64.2449 54.3197C64.1823 54.3067 57.8841 53.5196 55.4701 57.5484L55.3867 57.4992Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8711 49.8864L53.9441 49.8242C53.9702 49.8527 56.4154 52.7267 56.1182 55.7043L56.0218 55.694C56.3138 52.7578 53.8946 49.9148 53.8711 49.8864Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M53.668 64.4688C54.3562 62.7651 57.1768 62.1903 57.2967 62.167L57.315 62.2628C57.2863 62.268 54.4266 62.8506 53.7566 64.5051L53.668 64.4688Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0679 58.9692C51.9662 58.8346 51.9245 58.7776 51.9141 58.7543L52.0027 58.7129C52.0105 58.731 52.0731 58.8165 52.1461 58.9123C52.6544 59.6036 54.2055 61.7086 54.0152 63.1042L53.9188 63.0913C54.1039 61.7345 52.571 59.6528 52.0679 58.9692Z",
    fill: "#BEB8F2"
  })))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9131 65.536C55.8957 65.5429 55.8792 65.5507 55.8636 65.5593C54.8834 66.0073 53.7311 66.3232 52.3808 66.4086C52.1149 66.4069 51.8499 66.4051 51.5857 66.4034C51.3459 65.7872 51.2312 65.1554 52.0315 64.8913C53.2697 64.4822 53.2332 62.2943 52.8657 61.5305C52.4121 60.5854 51.4006 58.3665 53.3088 57.701C54.8964 57.1495 56.0356 57.1159 56.0852 55.06C56.1321 53.0068 57.2217 51.694 59.0961 51.7588C61.0721 51.8261 62.6076 49.1721 64.2473 49.9955C67.107 51.4274 64.6983 56.0258 61.3172 57.4369C57.936 58.8507 59.9381 60.0158 60.0815 61.691C60.277 63.9773 57.1435 63.5838 56.3484 64.5081C56.0773 64.8214 55.9522 65.1813 55.9131 65.536Z",
    fill: "url(#paint21_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M54.004 66.1699L53.9102 66.1544C55.0754 59.4949 59.4863 53.4258 65.4248 50.3213L65.4665 50.4016C59.5541 53.4957 55.1615 59.5363 54.004 66.1699Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9499 62.592L54.8561 62.5946C54.7857 59.9407 52.4395 57.9314 52.416 57.9107L52.476 57.8408C52.4994 57.8615 54.8769 59.8967 54.9499 62.592Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2514 64.9503L54.168 64.9089C55.3906 62.5035 60.3046 62.0374 60.3541 62.0322L60.3645 62.1228C60.315 62.128 55.4506 62.5915 54.2514 64.9503Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0996 56.7501L58.011 56.7164C58.8139 54.7331 57.4453 51.7529 57.4297 51.7244L57.5157 51.6855C57.5287 51.714 58.9156 54.7331 58.0996 56.7501Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9818 53.5528L60.9297 53.4751C62.9813 52.1443 66.2347 52.7631 66.266 52.7683L66.2503 52.8589C66.2164 52.8537 63.0022 52.2426 60.9818 53.5528Z",
    fill: "#FCFDFE"
  })))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0989 11.7267V65.7819C55.0989 66.4551 54.5983 67.0325 53.9805 67.0739L23.9466 69.0314C23.2558 69.078 22.6953 68.5342 22.6953 67.8196V10.4968C22.6953 9.78218 23.2558 9.22549 23.9466 9.25398L53.6755 11.7836C54.2933 11.8095 55.0989 11.0535 55.0989 11.7267Z",
    fill: "url(#paint22_linear_1466_4635)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M46.832 10.3392C46.832 9.9405 47.1396 9.61944 47.5176 9.6272L47.7757 9.61426L49.0114 10.1036V10.5516L46.832 10.3392Z",
    fill: "url(#paint23_linear_1466_4635)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9022 11.7267V65.7819C55.9022 66.4551 55.4017 67.0325 54.7839 67.0739L24.7474 69.0314C24.0566 69.078 23.4961 68.5342 23.4961 67.8196V10.4968C23.4961 9.78218 24.0566 9.22549 24.7474 9.25398L54.7839 10.4631C55.4017 10.4864 55.9022 11.0535 55.9022 11.7267Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5462 67.2836L24.7474 69.0314C24.0566 69.078 23.4961 68.5342 23.4961 67.8196V10.4968C23.4961 9.78218 24.0566 9.22549 24.7474 9.25398L34.5649 9.65013C31.9659 15.6986 32.323 19.862 33.2328 22.617C35.6025 29.8072 42.5524 30.1283 44.3564 37.4428C45.8162 43.3592 41.9893 46.0598 42.5003 52.5898C42.8131 56.6057 44.7526 61.7997 51.5462 67.2836Z",
    fill: "#D8DEE8"
  })))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2432 11.7008V65.8233C55.2432 66.0978 55.0373 66.336 54.7844 66.3541L24.7479 68.2727C24.4664 68.2908 24.2344 68.0656 24.2344 67.773V10.5252C24.2344 10.2327 24.4664 10.0022 24.7479 10.0152L54.7844 11.1829C55.0373 11.1933 55.2432 11.4263 55.2432 11.7008Z",
    fill: "url(#paint24_linear_1466_4635)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1748 36.4743C34.5517 36.5209 29.8906 31.6583 29.8906 25.6358C29.8906 19.6158 34.5517 14.8594 40.1748 15.0329C45.6857 15.2038 50.0887 20.0638 50.0887 25.8688C50.0887 31.6739 45.6857 36.4303 40.1748 36.4743Z",
    fill: "#D8DEE8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4167 25.8611C49.4167 31.2804 45.3187 35.7028 40.1753 35.7364C34.9355 35.7701 30.6133 31.2545 30.6133 25.6462C30.6133 20.038 34.9355 15.6182 40.1753 15.7735C45.3187 15.9263 49.4167 20.4393 49.4167 25.8611Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.4956 41.4431C52.4956 42.0826 52.0186 42.6108 51.4294 42.6212L28.442 43.0717C27.8007 43.0846 27.2793 42.5513 27.2793 41.8832C27.2793 41.2152 27.8007 40.6637 28.442 40.6533L51.4294 40.3038C52.0186 40.296 52.4956 40.8061 52.4956 41.4431Z",
    fill: "url(#paint25_linear_1466_4635)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4939 45.9979C52.4939 46.6374 52.0168 47.1682 51.4277 47.1838L32.5982 47.712C31.9647 47.7301 31.4512 47.2071 31.4512 46.5416C31.4512 45.8788 31.9647 45.3273 32.5982 45.3144L51.4277 44.8665C52.0168 44.8535 52.4939 45.3584 52.4939 45.9979Z",
    fill: "#D8DEE8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4524 47.8282H28.4315C27.7955 47.8464 27.2793 47.3414 27.2793 46.7019V46.5957C27.2793 45.9588 27.7955 45.428 28.4315 45.4125H28.4524C29.0885 45.3969 29.602 45.8992 29.602 46.5362V46.6424C29.602 47.2793 29.0885 47.8101 28.4524 47.8282Z",
    fill: "#B19AF3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4402 48.0538C27.679 48.0771 27.0586 47.4479 27.0586 46.6556C27.0586 45.8633 27.679 45.2031 28.4402 45.185C29.2015 45.1668 29.8167 45.796 29.8167 46.5857C29.8167 47.3729 29.2015 48.0331 28.4402 48.0538ZM28.4402 45.6381C27.9189 45.651 27.4966 46.1015 27.4966 46.6453C27.4966 47.1864 27.9189 47.6162 28.4402 47.6007C28.9616 47.5878 29.3839 47.1372 29.3839 46.5961C29.3839 46.0549 28.9616 45.6251 28.4402 45.6381Z",
    fill: "#D8DEE8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4939 50.1167C52.4939 50.7563 52.0168 51.2922 51.4277 51.3129L32.5982 51.9835C31.9647 52.0068 31.4512 51.4864 31.4512 50.8236C31.4512 50.1581 31.9647 49.6041 32.5982 49.5859L51.4277 48.9956C52.0168 48.9775 52.4939 49.4798 52.4939 50.1167Z",
    fill: "#D8DEE8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4524 52.1313H28.4315C27.7955 52.1546 27.2793 51.6548 27.2793 51.0153V50.9091C27.2793 50.2696 27.7955 49.7362 28.4315 49.7155H28.4524C29.0885 49.6948 29.602 50.1945 29.602 50.8314V50.9376C29.602 51.5746 29.0885 52.108 28.4524 52.1313Z",
    fill: "#B19AF3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4402 52.3588C27.679 52.3847 27.0586 51.7633 27.0586 50.9684C27.0586 50.1762 27.679 49.5133 28.4402 49.49C29.2015 49.4641 29.8167 50.0881 29.8167 50.8778C29.8167 51.6675 29.2015 52.3303 28.4402 52.3588ZM28.4402 49.9405C27.9189 49.9587 27.4966 50.4118 27.4966 50.9555C27.4966 51.4966 27.9189 51.9238 28.4402 51.9057C28.9616 51.8876 29.3839 51.4319 29.3839 50.8908C29.3839 50.3522 28.9616 49.925 28.4402 49.9405Z",
    fill: "#D8DEE8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4939 54.2388C52.4939 54.8758 52.0168 55.4143 51.4277 55.4402L32.5982 56.2558C31.9647 56.2843 31.4512 55.7665 31.4512 55.1036C31.4512 54.4408 31.9647 53.8815 32.5982 53.8582L51.4277 53.1229C52.0168 53.0996 52.4939 53.5993 52.4939 54.2388Z",
    fill: "#D8DEE8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4402 56.6629C27.679 56.6966 27.0586 56.0778 27.0586 55.2855C27.0586 54.4932 27.679 53.8226 28.4402 53.7941C29.2015 53.763 29.8167 54.3818 29.8167 55.1715C29.8167 55.9612 29.2015 56.6293 28.4402 56.6629ZM28.4402 54.2472C27.9189 54.2679 27.4966 54.7236 27.4966 55.2673C27.4966 55.8085 27.9189 56.2331 28.4402 56.2098C28.9616 56.1865 29.3839 55.7308 29.3839 55.1897C29.3839 54.6485 28.9616 54.2265 28.4402 54.2472Z",
    fill: "#D8DEE8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4939 58.3582C52.4939 58.9977 52.0168 59.5389 51.4277 59.5699L32.5982 60.5279C31.9647 60.559 31.4512 60.0489 31.4512 59.3835C31.4512 58.7207 31.9647 58.1588 32.5982 58.1303L51.4277 57.25C52.0168 57.2241 52.4939 57.7186 52.4939 58.3582Z",
    fill: "#D8DEE8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4524 60.7408H28.4315C27.7955 60.7718 27.2793 60.2799 27.2793 59.643V59.5368C27.2793 58.8973 27.7955 58.3535 28.4315 58.3251L28.4524 58.3225C29.0885 58.294 29.602 58.7859 29.602 59.4229V59.529C29.602 60.166 29.0885 60.7071 28.4524 60.7408Z",
    fill: "#B19AF3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4402 60.9661C27.679 61.0049 27.0586 60.3913 27.0586 59.599C27.0586 58.8067 27.679 58.1335 28.4402 58.0972C29.2015 58.061 29.8167 58.6746 29.8167 59.4643C29.8167 60.254 29.2015 60.9272 28.4402 60.9661ZM28.4402 58.5503C27.9189 58.5736 27.4966 59.0371 27.4966 59.5783C27.4966 60.1194 27.9189 60.5389 28.4402 60.513C28.9616 60.4871 29.3839 60.0262 29.3839 59.485C29.3839 58.9465 28.9616 58.527 28.4402 58.5503Z",
    fill: "#D8DEE8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8403 18.5284C43.6573 19.6314 44.1657 21.5552 44.2804 22.0213C45.0833 25.2501 42.6146 26.8916 43.6651 29.1727C44.528 31.0447 46.9655 31.6351 46.8638 31.8396C46.7752 32.0235 45.0338 31.1302 43.3549 30.7237C37.8753 29.4032 33.1151 33.2999 32.4399 32.3264C31.9602 31.6351 34.7522 30.2628 35.3283 27.0573C35.8732 24.0202 33.8815 22.4071 35.0911 20.1415C35.8966 18.6294 37.4555 18.0883 37.7214 18.0002C39.7835 17.3167 41.5614 18.3601 41.8403 18.5284Z",
    fill: "url(#paint26_linear_1466_4635)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6133 32.4974C36.2129 29.0364 42.4807 29.0321 49.4167 32.4844C48.5321 35.4482 45.4517 37.0277 40.1753 37.2227C34.7426 37.423 31.5552 35.8478 30.6133 32.4974Z",
    fill: "url(#paint27_linear_1466_4635)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1946 25.7658L41.2754 27.8838C41.3093 28.7978 41.8567 29.6004 42.6571 29.9189L45.4855 30.9598C41.3527 32.6272 37.6518 32.6281 34.3828 30.9624L36.9454 30.0458C37.7118 29.7713 38.2619 29.0645 38.3687 28.2178L38.6842 25.7373L41.1946 25.7658Z",
    fill: "url(#paint28_linear_1466_4635)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0148 27.4172C37.727 27.0496 37.0362 25.9362 36.6269 25.2759C35.9413 24.1678 34.995 21.8763 35.8866 20.5713C35.9361 20.4988 35.9935 20.4626 36.0977 20.3357C36.7025 19.5797 36.6322 18.9608 36.8694 18.5647C37.4377 17.6067 39.7474 18.0106 39.8881 18.0339C42.3569 18.487 43.4283 20.7344 43.4492 20.7836C43.4631 20.8147 43.4761 20.8458 43.4883 20.8769C43.6368 21.2419 44.4971 23.3288 43.4205 25.2863C42.5576 26.8528 40.6963 27.8937 39.0148 27.4172Z",
    fill: "url(#paint29_linear_1466_4635)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5082 23.5927C42.5082 25.6848 41.3143 27.9271 39.8362 27.9141C38.3502 27.9038 37.1406 25.6227 37.1406 23.5099C37.1406 21.3945 38.3502 20.263 39.8362 20.2966C41.3143 20.3277 42.5082 21.498 42.5082 23.5927Z",
    fill: "url(#paint30_linear_1466_4635)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6634 22.4851C37.0206 20.9186 38.5769 19.6084 40.2714 19.6291C40.5659 19.6317 41.812 19.6861 42.7297 20.714C43.8819 22.0035 44.0148 24.2613 43.0399 25.3177C42.7297 25.6543 42.0779 26.1152 41.5904 25.8899C40.8214 25.5352 41.3897 23.9143 40.3756 22.7725C39.7317 22.0475 38.5873 21.6669 37.9304 22.063C36.9372 22.6611 37.3073 24.8594 37.0519 24.8723C36.8616 24.8801 36.3897 23.6891 36.6634 22.4851Z",
    fill: "url(#paint31_linear_1466_4635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7359 66.6104L24.7479 68.2727C24.4664 68.2908 24.2344 68.0656 24.2344 67.773V10.5252C24.2344 10.2327 24.4664 10.0022 24.7479 10.0152L34.2604 10.3854C31.995 16.0377 32.3626 19.9759 33.2333 22.6169C35.603 29.8072 42.5529 30.1283 44.3569 37.4428C45.8167 43.3592 41.9898 46.0598 42.5008 52.5898C42.8006 56.4374 44.5941 61.3724 50.7359 66.6104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4778 18.4719L50.7276 16.3073L47.9512 18.3398V11.5095C47.9512 10.9761 47.7088 10.4634 47.2943 10.1216L47.2734 10.1035L52.5159 10.3081C53.0477 10.3288 53.4778 10.7871 53.4778 11.3334V18.4719Z",
    fill: "#D8DEE8"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9798 18.472L51.2295 16.1805L48.4532 18.3322V11.1031C48.4532 10.5386 48.2107 9.99487 47.7962 9.63238L47.7754 9.61426L53.0178 9.82916C53.5496 9.85247 53.9798 10.3392 53.9798 10.914V18.472Z",
    fill: "url(#paint32_linear_1466_4635)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1466_4635",
    x1: 11533,
    y1: 8900.85,
    x2: 23352.9,
    y2: 31929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1466_4635",
    x1: 6980,
    y1: 12009,
    x2: 32623.7,
    y2: 56033.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1466_4635",
    x1: 4034.89,
    y1: 28445.2,
    x2: 38703.1,
    y2: 28445.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1466_4635",
    x1: 4034.89,
    y1: 28445.2,
    x2: 38703.1,
    y2: 28445.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1466_4635",
    x1: 58047.8,
    y1: 55397.9,
    x2: 18494.6,
    y2: 94704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1466_4635",
    x1: 6823.89,
    y1: 3607.1,
    x2: 27813.1,
    y2: 3607.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1466_4635",
    x1: 7174.4,
    y1: 7368.53,
    x2: 18845.3,
    y2: 7368.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1466_4635",
    x1: 5648.84,
    y1: 6921.6,
    x2: 5595.8,
    y2: 5327.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1466_4635",
    x1: 4334.2,
    y1: 6949.1,
    x2: 2130.84,
    y2: 8214.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1466_4635",
    x1: 45172.3,
    y1: 28725.1,
    x2: 71340.3,
    y2: 28725.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1466_4635",
    x1: 45172.3,
    y1: 28725.1,
    x2: 71340.3,
    y2: 28725.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1466_4635",
    x1: 41705,
    y1: 31945.9,
    x2: 55937,
    y2: 27091.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1466_4635",
    x1: 37990.2,
    y1: 3288.55,
    x2: 53834.2,
    y2: 3288.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1466_4635",
    x1: 29912.6,
    y1: 6901.02,
    x2: 38724.6,
    y2: 6901.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1466_4635",
    x1: 11838.5,
    y1: 5416.9,
    x2: 11842.9,
    y2: 6331.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1466_4635",
    x1: 10352.3,
    y1: 5025.6,
    x2: 9956.24,
    y2: 6864.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1466_4635",
    x1: 12743.3,
    y1: 3947.48,
    x2: 12664.2,
    y2: 4581.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1466_4635",
    x1: 1731.16,
    y1: 1211.4,
    x2: 1611.28,
    y2: 1599.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1466_4635",
    x1: 1644.65,
    y1: 1189.05,
    x2: 1518.38,
    y2: 1596.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1466_4635",
    x1: 33450.4,
    y1: 30328.5,
    x2: 17599.4,
    y2: 50503.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1466_4635",
    x1: 52244.9,
    y1: 44932.9,
    x2: 35961.3,
    y2: 61278.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1466_4635",
    x1: 30910.7,
    y1: 31430,
    x2: 24773,
    y2: 40487.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1466_4635",
    x1: 28233.2,
    y1: 21255.5,
    x2: 68510.8,
    y2: 21255.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1466_4635",
    x1: 3962.05,
    y1: 355.762,
    x2: 4144.25,
    y2: 355.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1466_4635",
    x1: 93915.9,
    y1: 62306.4,
    x2: 36505.3,
    y2: 112310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1466_4635",
    x1: 26413.6,
    y1: 4343.78,
    x2: 50805.4,
    y2: 4343.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1466_4635",
    x1: 31224,
    y1: 11468.1,
    x2: 20919.9,
    y2: 23609.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1466_4635",
    x1: 36193.4,
    y1: 8678.59,
    x2: 36030.4,
    y2: 10604.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1466_4635",
    x1: 19419.7,
    y1: 6631.5,
    x2: 19424.3,
    y2: 8169.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1466_4635",
    x1: 16367.7,
    y1: 6247.02,
    x2: 10331.8,
    y2: 12590.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1466_4635",
    x1: 9085.85,
    y1: 4853.34,
    x2: 8395.93,
    y2: 8130.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1466_4635",
    x1: 13822.7,
    y1: 3964.37,
    x2: 9861.24,
    y2: 9301.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1466_4635",
    x1: 14072.2,
    y1: 3387.07,
    x2: 10838.7,
    y2: 7401.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1466_4635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 74,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.3e999add52d2888a5931feb2702faa67.svg";
export { ForwardRef as ReactComponent };